module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d3-layout-transparent mdl-layout mdl-js-layout mdl-layout--fixed-header mdl-layout--no-desktop-drawer-button"
  }, [(!_vm.isLineContentsMode) ? _c('header', {
    staticClass: "mdl-layout__header mdl-layout__header--scroll"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('div', {
    staticClass: "mdl-layout-spacer mdl-layout--small-screen-only"
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-layout-title"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    staticClass: "d3-header-logo",
    attrs: {
      "src": "/static/img/dddisc-logo-header.png",
      "alt": "DDDisc ロゴ"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  }), _vm._v(" "), _c('nav', {
    staticClass: "mdl-navigation mdl-layout--small-screen-only"
  }, [_c('router-link', {
    staticClass: "d3-header-help mdl-navigation__link",
    attrs: {
      "to": {
        name: 'support'
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("help_outline")])])], 1), _vm._v(" "), _c('nav', {
    staticClass: "mdl-navigation mdl-layout--large-screen-only"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--primary mdl-js-ripple-effect-takei",
    on: {
      "click": function($event) {
        _vm.onClickNavigation('requestFreeSample')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("request.sample_title")) + "\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("nav.whats_dddisc")))]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": {
        name: 'solutions'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("nav.solutions")))]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": {
        name: 'support'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("help.title")))]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("contact.title")))]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": {
        name: 'company'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("company.title")))])], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.isLineContentsMode) ? _c('div', {
    staticClass: "d3-drawer mdl-layout__drawer"
  }, [_c('nav', {
    staticClass: "mdl-navigation"
  }, [_c('a', {
    staticClass: "mdl-navigation__link",
    on: {
      "click": function($event) {
        _vm.onClickNavigation('home')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("nav.home")))]), _vm._v(" "), _c('a', {
    staticClass: "mdl-navigation__link",
    on: {
      "click": function($event) {
        _vm.onClickNavigation('about')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("nav.whats_dddisc")))]), _vm._v(" "), _c('a', {
    staticClass: "mdl-navigation__link",
    on: {
      "click": function($event) {
        _vm.onClickNavigation('support')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("help.title")))]), _vm._v(" "), _c('a', {
    staticClass: "mdl-navigation__link",
    on: {
      "click": function($event) {
        _vm.onClickNavigation('termsOfService')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("tos.title")))]), _vm._v(" "), _c('a', {
    staticClass: "mdl-navigation__link",
    on: {
      "click": function($event) {
        _vm.onClickNavigation('privacyPolicy')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("privacy.title")))]), _vm._v(" "), _c('a', {
    staticClass: "mdl-navigation__link",
    on: {
      "click": function($event) {
        _vm.onClickNavigation('solutions')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("nav.solutions")))]), _vm._v(" "), _c('a', {
    staticClass: "mdl-navigation__link",
    on: {
      "click": function($event) {
        _vm.onClickNavigation('showCase')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("nav.showcase")))]), _vm._v(" "), _c('a', {
    staticClass: "mdl-navigation__link",
    on: {
      "click": function($event) {
        _vm.onClickNavigation('requestFreeSample')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("request.sample_title")))]), _vm._v(" "), _c('a', {
    staticClass: "mdl-navigation__link",
    on: {
      "click": function($event) {
        _vm.onClickNavigation('contact')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("contact.title")))]), _vm._v(" "), _c('a', {
    staticClass: "mdl-navigation__link",
    on: {
      "click": function($event) {
        _vm.onClickNavigation('company')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("company.title")))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  }), _vm._v(" "), _c('button', {
    staticClass: "d3-scan-button mdl-button mdl-js-button mdl-button--raised mdl-button--primary mdl-js-ripple-effect-takei",
    on: {
      "click": function($event) {
        _vm.onClickNavigation('scanInstruction')
      }
    }
  }, [_c('img', {
    staticClass: "d3-scan-button-icon",
    attrs: {
      "src": "/static/img/scan/dddisc-logo-white-square-70.png",
      "alt": "dddi.sc ディスクをスキャン"
    }
  }), _vm._v(_vm._s(_vm.$t("nav.scan")) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('main', {
    staticClass: "mdl-layout__content",
    attrs: {
      "id": "main"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('snack-bar'), _vm._v(" "), _c('loading'), _vm._v(" "), _c('flash')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31faaec8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 1086
// module chunks = 38